// Convert decimal minutes to MM:SS format (for minutes display)
export const formatDecimalMinutesToMinutesSeconds = (decimalMinutes) => {
  console.log("decimalMinutes", decimalMinutes);

  if (!decimalMinutes || isNaN(decimalMinutes)) return "00:00";

  // Round to avoid floating point issues
  const totalSeconds = Math.round(parseFloat(decimalMinutes) * 60);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `${minutes.toString().padStart(2, "0")}:${seconds
    .toString()
    .padStart(2, "0")}`;
};

// Convert decimal minutes to HH:MM:SS format (for hours display)
export const formatDecimalMinutesToHours = (decimalMinutes) => {
  console.log("decimalMinutes", decimalMinutes);

  if (!decimalMinutes || isNaN(decimalMinutes)) return "00:00:00";

  // Use precise calculation with rounding
  const totalSeconds = Math.round(parseFloat(decimalMinutes) * 60);
  const hours = Math.floor(totalSeconds / 3600);
  const remainingSeconds = totalSeconds % 3600;
  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;

  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
};

// Convert MM:SS to decimal minutes (for minutes input)
export const formatMinutesSecondsToDecimal = (mmssString) => {
  if (!mmssString) return 0;

  const parts = mmssString.split(":");
  let minutes = 0,
    seconds = 0;

  if (parts.length === 2) {
    minutes = parseInt(parts[0]) || 0;
    seconds = parseInt(parts[1]) || 0;
  } else if (parts.length === 1) {
    minutes = parseInt(parts[0]) || 0;
  }

  // Use precise decimal calculation
  const totalMinutes = minutes + seconds / 60;
  return parseFloat(totalMinutes.toFixed(6)); // More precision to avoid rounding errors
};

// Convert HH:MM:SS to decimal minutes (for hours input)
export const formatHoursToDecimalMinutes = (hhmmssString) => {
  if (!hhmmssString) return 0;

  const parts = hhmmssString.split(":");
  let hours = 0,
    minutes = 0,
    seconds = 0;

  if (parts.length === 3) {
    hours = parseInt(parts[0]) || 0;
    minutes = parseInt(parts[1]) || 0;
    seconds = parseInt(parts[2]) || 0;
  } else if (parts.length === 2) {
    hours = parseInt(parts[0]) || 0;
    minutes = parseInt(parts[1]) || 0;
  }

  const totalMinutes = hours * 60 + minutes + seconds / 60;
  return parseFloat(totalMinutes.toFixed(6)); // More precision
};

// Alternative: More robust version that handles the conversion chain better
export const formatDecimalMinutesToHoursFixed = (decimalHours) => {
  if (!decimalHours || isNaN(decimalHours)) return "00:00:00";

  // Convert HOURS to total seconds
  const totalSeconds = Math.round(parseFloat(decimalHours) * 3600);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
};

// Convert decimal hours to HH:MM:SS format
export const formatDecimalHoursToHoursMinutes = (decimalHours) => {
  console.log("formatDecimalHoursToHoursMinutes input:", decimalHours);

  if (!decimalHours || isNaN(decimalHours)) return "00:00:00";

  // Convert HOURS to total seconds (hours × 3600)
  const totalSeconds = Math.round(parseFloat(decimalHours) * 3600);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const result = `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

  console.log("formatDecimalHoursToHoursMinutes result:", result);
  console.log("Calculation details:", {
    decimalHours,
    totalSeconds,
    hours,
    minutes,
    seconds,
  });

  return result;
};
